/**
 * UPT-2124 J4a (spec `web/SPEC-UPT-2124-J4.md` §3 « Montage ») — le POINT DE MONTAGE UNIQUE de l'acteur d'interface : monté à côté du tiroir du
 * copilote (`ClientProviders`), donc sur toutes les pages connectées (portails, `/studio`, pages racine comme `/profile`), hors pages publiques
 * (`header/headerContext.ts`), quand la voix est visible
 * (add-on `core-addon-voice` actif ou poste local). Il enregistre les outils `ui_*` (`useUiVoiceTools`) et rend le fantôme (`UiGhost`).
 * Rien n'est monté ailleurs : pas de micro, pas de session ici — seulement les outils que le modèle vocal peut appeler.
 * Retour d'Olivier du 20.10 : la liste fermée `/portal`, `/adminportal`, `/make` excluait `/studio` — Géode y répondait « je ne peux pas
 * cliquer ». Même règle inversée que l'en-tête : toute page connectée sauf les pages publiques.
 */
import { useAuth } from '@clerk/clerk-react';
import { useLocation } from 'react-router';
import { useActiveModules } from '@/uptk/core/hooks/useActiveModules';
import { isVoiceVisible } from '../voiceVisibility';
import { isPublicPage } from '../../header/headerContext';
import { UiGhost } from './UiGhost';
import { useUiVoiceTools } from './useUiVoiceTools';

function UiVoiceActive() {
  useUiVoiceTools();
  return <UiGhost />;
}

export function UiVoiceHost() {
  const { isSignedIn } = useAuth();
  const location = useLocation();
  const { modules } = useActiveModules();
  const onAppRoute = !isPublicPage(location.pathname);
  if (!isSignedIn || !onAppRoute || !isVoiceVisible(modules)) {
    return null;
  }
  return <UiVoiceActive />;
}

export default UiVoiceHost;
